import { Link } from "react-router-dom";

const footerLinks = [
  { to: "/", label: "Inicio" },
  { to: "/nosotros", label: "Nosotros" },
  { to: "/proyectos", label: "Proyectos" },
  { to: "/inversion", label: "Inversión" },
  { to: "/contacto", label: "Contacto" },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="px-4 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center rounded-md bg-white/95 px-2 py-1">
                <img
                  src="https://static.readdy.ai/image/6e7b8f0ab6ca5454b0b0e1ae719b1e05/deb5691b4c1ab30634e35e35a0b57bed.jpeg"
                  alt="Inmobiliaria ADJ"
                  className="h-10 w-auto object-contain"
                />
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-100/70 max-w-xs">
              Desarrollamos proyectos residenciales que combinan diseño, seguridad, calidad e
              innovación en la Región Metropolitana.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-background-50">
              Navegación
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-100/70 hover:text-primary-300 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-background-50">
              Contacto
            </h4>
            <ul className="flex flex-col gap-3 text-sm text-background-100/70">
              <li>
                <a href="tel:+56982998322" className="hover:text-primary-300 transition-colors">
                  <i className="ri-phone-line mr-2 text-primary-300" />
                  +56 9 8299 8322
                </a>
              </li>
              <li>
                <a href="mailto:ventas@iadj.cl" className="hover:text-primary-300 transition-colors">
                  <i className="ri-mail-line mr-2 text-primary-300" />
                  ventas@iadj.cl
                </a>
              </li>
              <li className="leading-relaxed">
                <i className="ri-map-pin-line mr-2 text-primary-300" />
                Alonso de Córdova 5870, oficina 1013, Las Condes
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-background-50">
              Síguenos
            </h4>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/inmobiliaria_adj"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center rounded-md border border-background-100/20 text-background-100 hover:border-primary-400 hover:text-primary-300 transition-colors"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href="#"
                aria-label="LinkedIn"
                className="w-10 h-10 flex items-center justify-center rounded-md border border-background-100/20 text-background-100 hover:border-primary-400 hover:text-primary-300 transition-colors"
              >
                <i className="ri-linkedin-fill text-lg" />
              </a>
            </div>
            <p className="text-xs text-background-100/50 mt-2">
              Redes sociales oficiales próximamente.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-100/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} Inmobiliaria ADJ. Todos los derechos reservados.
          </p>
          <p className="text-xs text-background-100/40">
            Inmobiliaria ADJ SpA · Santiago de Chile
          </p>
        </div>
      </div>
    </footer>
  );
}